import createMapMarkerHoverToolTip from "./MapMarkerHoverToolTip";
import ImageCreditToggle from "./image-credit-toggle";

let infoboxOptions;
let mapInfoBox;
let hoverInfoBox;
let map;
let Mustache;
let Mzr = window.Modernizr;
let parkEntryInfoBox;
let isInfoBoxHovered;

let popupSettings = {
  mapPopupTemplate: "",
  accommodationListingMapPopupPartial: "",
  campgroundListingMapPopupPartial: "",
  educationExcursionListingMapPopupPartial: "",
  educationIncursionListingMapPopupPartial: "",
  educationResourceListingMapPopupPartial: "",
  parkListingMapPopupPartial: "",
  ttdActivityAttractionListingMapPopupPartial: "",
  ttdIteneraryListingMapPopupPartial: "",
  ttdTourAndEventListingMapPopupPartial: "",
  ttdVolunteeringListingMapPopupPartial: "",
  venueListingMapPopupPartial: "",
  alertsListingTemplate: "",
  mapSidebarTemplate: "",
  itineraryDayTemplate: "",
  aisSpeciesTemplate: "",
  aisSpeciesSelectorTemplate: "",
  aisMapMarkerHoverTooltipTemplate: ""
}

export function buildHtml(m) {
  const hasThumb =
    typeof m.PreviewImageUrl != 'undefined' && m.PreviewImageUrl != '';

  let infoBoxClass="";
  if(m.HasOverrideDescription){
    switch (m.PType) {
      case 'region':
      case 'visit':
          infoBoxClass = 'visit';
        break;
      case 'things':
        infoBoxClass = 'things';
        break;
      case 'camping':
      case 'accommodation':
        infoBoxClass = 'camping';
        break;
      case 'venue':
        infoBoxClass = 'venue';
        break;
      case 'alert':
        infoBoxClass = 'alert';
        break;
      default:
        infoBoxClass = 'things';
    }
  }  
  const thumbLink = hasThumb
    ? `<div class="npws-customMap-gmap-iw-wrap">
        <button class="bttn-link npws-customMap-gmap-iw-link text-left width-full" onclick="return appCustomMaps.useGateway('${m.MapPinId}');">
          <img class="npws-customMap-gmap-iw-image" src="${m.PreviewImageUrl}"/>
        </button>
      </div>`
    : ``;
    const mapPinLinkTarget = m.MapPinHasLink && m.MapPinLinkTarget != ''
    ? `target="${m.MapPinLinkTarget}"`
    : ``;
    const mapPinLinkText = m.MapPinHasLink
    ? `<div class="my-1">
      <a type="button" class="bttn bttn-primary bttn-smbttn bttn-primary bttn-sm button flex-items-center ${ m.MapPinLinkClass != '' ? m.MapPinLinkClass : ''}" href="${m.MapPinUrl}" ${mapPinLinkTarget}>
        <span>${ m.MapPinLinkText != '' ? m.MapPinLinkText : 'Read more'}</span>
        <svg class="ml-2" fill="none" xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 8 12"><path d="M1.055 12L0 10.945 4.945 6 0 1.055 1.055 0l6 6-6 6z" fill="currentColor" /></svg>
      </a>
    </div>`
    : ``;
    
    const ctaLink = m.HasTimeLapse
    ? `<div class="my-1">
        <button type="button" class="bttn bttn-primary bttn-smbttn bttn-primary bttn-sm d-flex flex-items-center" onclick="return appCustomMaps.useGateway('${m.MapPinId}');">
          <span>${m.TimeLapseButtonText}</span>
          <svg class="ml-2" fill="none" xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 8 12"><path d="M1.055 12L0 10.945 4.945 6 0 1.055 1.055 0l6 6-6 6z" fill="currentColor" /></svg>
        </button>
      </div>`
    : `${mapPinLinkText}`;
    
    const headingText = m.HasTimeLapse
    ? `<button class="bttn-link text-left underline text-green" onclick="return appCustomMaps.useGateway('${m.MapPinId}');">${m.Title}</button>`
    : m.MapPinHasLink 
      ? `<a type="button" class="bttn-link text-left underline ${ typeof m.MapPinLinkClass !== 'undefined' && m.MapPinLinkClass !== null && m.MapPinLinkClass != '' ? m.MapPinLinkClass : 'text-green'}"  href="${m.MapPinUrl}" ${mapPinLinkTarget}>${m.Title}</a>`
      : `<span class="text-left ${ typeof m.MapPinLinkClass !== 'undefined' && m.MapPinLinkClass !== null && m.MapPinLinkClass != '' ? m.MapPinLinkClass : 'text-green'}">${m.Title}</span>`;

  return `
  <div class="npws-customMap-gmap-iw p-1 ${infoBoxClass}">
    <div class="d-flex flex-column">
      <h2 class="h4 mb-2 mt-0">
        ${headingText}
      </h2>
      ${thumbLink}
      <div class="f6 helvetica-regular">${m.Description}</div>
    </div>
    ${ctaLink}
    </div>`;
}
export function loadMapPinContent(marker){
  
  if(marker==null)return;
  var webServiceUrl = '/api/Map/GetItem?id=' + marker.sourceItem;
  $.getJSON(webServiceUrl, function (popupContent) {
    var type = popupContent.type;
    switch (type) {
      case 'region':
        popupContent.section = 'visit';
        //module.regionLayerSettings.regionItemDetailsCache[marker.id] =
          popupContent;
        break;
      case 'visit':
        popupContent.section = 'visit';
        break;
      case 'things':
        popupContent.section = 'things';
        break;
      case 'camping':
        popupContent.section = 'camping';
        break;
      case 'accommodation':
        popupContent.section = 'camping';
        break;
      case 'venue':
        popupContent.section = 'venue';
        break;
      case 'alert':
        popupContent.section = 'alert';
        break;
      default:
        popupContent.section = 'things';
    }
    var mapPopupTemplate= popupSettings.mapPopupTemplate;
    //alert(type + " " + popupContent.jsonTemplate  + " " + popupContent.section );
    var infoboxContent;
    switch (popupContent.jsonTemplate) {
      case 'accommodationListing':
        infoboxContent = Mustache.render(mapPopupTemplate, popupContent, {
          details: popupSettings.accommodationListingMapPopupPartial,
        });
        break;
      case 'campgroundListing':
        infoboxContent = Mustache.render(mapPopupTemplate, popupContent, {
          details: popupSettings.campgroundListingMapPopupPartial,
        });
        break;
      case 'educationExcursionListing':
        popupContent.section = 'education';
        infoboxContent = Mustache.render(mapPopupTemplate, popupContent, {
          details: popupSettings.educationExcursionListingMapPopupPartial,
        });
        break;
      case 'educationIncursionListing':
        popupContent.section = 'education';
        infoboxContent = Mustache.render(mapPopupTemplate, popupContent, {
          details: popupSettings.educationIncursionListingMapPopupPartial,
        });
        break;
      case 'educationResourceListing':
        popupContent.section = 'education';
        infoboxContent = Mustache.render(mapPopupTemplate, popupContent, {
          details: popupSettings.educationResourceListingMapPopupPartial,
        });
        break;
      case 'parkListing':
        infoboxContent = Mustache.render(mapPopupTemplate, popupContent, {
          details: popupSettings.parkListingMapPopupPartial,
        });
        break;
      case 'parkalertListing':
        infoboxContent = Mustache.render(mapPopupTemplate, popupContent, {
          details: popupSettings.parkAlertListingMapPopupPartial,
        });
        break;
      case 'ttdActivityAttractionListing':
        infoboxContent = Mustache.render(mapPopupTemplate, popupContent, {
          details: popupSettings.ttdActivityAttractionListingMapPopupPartial,
        });
        break;
      case 'ttdIteneraryListing':
        infoboxContent = Mustache.render(mapPopupTemplate, popupContent, {
          details: popupSettings.ttdIteneraryListingMapPopupPartial,
        });
        break;
      case 'ttdTourAndEventListing':
        infoboxContent = Mustache.render(mapPopupTemplate, popupContent, {
          details: popupSettings.ttdTourAndEventListingMapPopupPartial,
        });
        break;
      case 'ttdVolunteeringListing':
        infoboxContent = Mustache.render(mapPopupTemplate, popupContent, {
          details: popupSettings.ttdVolunteeringListingMapPopupPartial,
        });
        break;
      case 'venueListing':
        infoboxContent = Mustache.render(mapPopupTemplate, popupContent, {
          details: popupSettings.venueListingMapPopupPartial,
        });
        break;
      default:
        infoboxContent = Mustache.render(mapPopupTemplate, popupContent);
        break;
    }
    createLargeInfobox(infoboxContent, marker);
  });
}

export function loadMapPinAisContent(marker, aisReserveAssetData){
  
  if(marker==null)return;
  var webServiceUrl = '/api/AisApi/GetAisAsset/' + aisReserveAssetData.LinkedAssetId;
  //console.log(webServiceUrl);
  $.getJSON(webServiceUrl, function (jsonAisAsset) {
    const mergedJSON = Object.assign({}, jsonAisAsset, aisReserveAssetData);
    mergedJSON.hasCTASection = mergedJSON.isSharedSite || mergedJSON.CTA_Link;
    if(mergedJSON.CTA_Link != null){
      mergedJSON.CTA_Link.Text = mergedJSON.CTA_Link.Text == null || mergedJSON.CTA_Link.Text == "" ? "See profile" : mergedJSON.CTA_Link.Text;
    }
    mergedJSON.AreaHectares = parseFloat(mergedJSON.AreaHectares).toFixed(2);
    //console.log(mergedJSON);
    var aisSpeciesTemplate= popupSettings.aisSpeciesTemplate;
    var infoboxContent = Mustache.render(aisSpeciesTemplate, mergedJSON);
    createLargeInfobox(infoboxContent, marker, "ais", ImageCreditToggle);
  });
}

export function loadMapPinAisSpeciesSelectorContent(marker){
  var aisSpeciesSelectorTemplate= popupSettings.aisSpeciesSelectorTemplate;
  var infoboxContent = Mustache.render(aisSpeciesSelectorTemplate, marker);
  createLargeInfobox(infoboxContent, marker, "species");  
}

export function loadMapPinHoverTooltip(marker, gMap) {
  const htmlTemplate = popupSettings.aisMapMarkerHoverTooltipTemplate;
  // Bail on empty template
  if (htmlTemplate.trim() === '') return; 

  const dataObject = {
    heading: marker.aisReserveAssetData.ReserveName,
    moreThanOneSpecies: marker.species > 1,
    species:  marker.species > 1 ? marker.allSpecies : marker.aisReserveAssetData
  }
  const tooltipContent = Mustache.render(htmlTemplate, dataObject);
  return createMapMarkerHoverToolTip(tooltipContent, marker, gMap);  
}

export function loadScripts() {    
  $.getScript('/assets/NPWS/js/lib/map-libraries.min.js', function () {
    infoboxOptions = {
      alignBottom: true,
      disableAutoPan: false,
      maxWidth: 380,
      maxHeight: 500,
      pixelOffset: new google.maps.Size(5, 5),
      zIndex: null,
      closeBoxURL: '',
      infoBoxClearance: new google.maps.Size(5, 5),
      isHidden: false,
      pane: 'floatPane',
      enableEventPropagation: false,
    };
    Mustache=window.Mustache;
  });

  // Retrieve markup used by infobox and alerts listing and store it for later
  // The template and mustache library will be executed on pin click
  $.ajax({
    url: '/assets/NPWS/templates/infobox-template.html',
  }).done(function (data) {
    popupSettings.mapPopupTemplate = data;
  });

  $.ajax({
    url: '/assets/NPWS/templates/partials/accommodationListing.html',
  }).done(function (data) {
    popupSettings.accommodationListingMapPopupPartial = data;
  });
  $.ajax({
    url: '/assets/NPWS/templates/partials/campgroundListing.html',
  }).done(function (data) {
    popupSettings.campgroundListingMapPopupPartial = data;
  });
  $.ajax({
    url: '/assets/NPWS/templates/partials/educationExcursionListing.html',
  }).done(function (data) {
    popupSettings.educationExcursionListingMapPopupPartial = data;
  });
  $.ajax({
    url: '/assets/NPWS/templates/partials/educationIncursionListing.html',
  }).done(function (data) {
    popupSettings.educationIncursionListingMapPopupPartial = data;
  });
  $.ajax({
    url: '/assets/NPWS/templates/partials/educationResourceListing.html',
  }).done(function (data) {
    popupSettings.educationResourceListingMapPopupPartial = data;
  });
  $.ajax({
    url: '/assets/NPWS/templates/partials/parkListing.html',
  }).done(function (data) {
    popupSettings.parkListingMapPopupPartial = data;
  });
  $.ajax({
    url: '/assets/NPWS/templates/partials/ttdActivityAttractionListing.html',
  }).done(function (data) {
    popupSettings.ttdActivityAttractionListingMapPopupPartial = data;
  });
  $.ajax({
    url: '/assets/NPWS/templates/partials/ttdIteneraryListing.html',
  }).done(function (data) {
    popupSettings.ttdIteneraryListingMapPopupPartial = data;
  });
  $.ajax({
    url: '/assets/NPWS/templates/partials/ttdTourAndEventListing.html',
  }).done(function (data) {
    popupSettings.ttdTourAndEventListingMapPopupPartial = data;
  });
  $.ajax({
    url: '/assets/NPWS/templates/partials/ttdVolunteeringListing.html',
  }).done(function (data) {
    popupSettings.ttdVolunteeringListingMapPopupPartial = data;
  });
  $.ajax({
    url: '/assets/NPWS/templates/partials/venueListing.html',
  }).done(function (data) {
    popupSettings.venueListingMapPopupPartial = data;
  });

  $.ajax({
    url: '/assets/NPWS/templates/alerts-listing-template.html',
  }).done(function (data) {
    popupSettings.alertsListingTemplate = data;
  });

  if ($('#listingFilter').length) {
    // Template for the tiles that sit to the left of the map
    $.ajax({
      url: '/assets/NPWS/templates/map-sidebar-template.html',
    }).done(function (data) {
      popupSettings.mapSidebarTemplate = data;
    });

    if ($('.itinerary').length) {
      $.ajax({
        url: '/assets/NPWS/templates/itinerary-day-template.html',
      }).done(function (data) {
        popupSettings.itineraryDayTemplate = data;
      });
    }
  }
  $.ajax({
    url: '/assets/NPWS/templates/aisSpecies-template.html',
  }).done(function (data) {
    popupSettings.aisSpeciesTemplate = data;
  });
  $.ajax({
    url: '/assets/NPWS/templates/aisSpeciesSelector-template.html',
  }).done(function (data) {
    popupSettings.aisSpeciesSelectorTemplate = data;
  });
  
  $.ajax({
    url: '/assets/NPWS/templates/aisMarker-hover-tooltip-template.html',
  }).done(function (data) {
    popupSettings.aisMapMarkerHoverTooltipTemplate = data;
  });

  //return popupSettings;
}

export function openInfoWindow(gMap,marker){
  map=gMap;
  closeAllWindows();
  gMap.showPopup(marker);
}
export function closeAllWindows(){
  closeHoverInfoBox(); //close hover infobox
  closeInfoBox(); // close any existing info boxes
  closeMapInfoWindow();
}

export function createLargeInfobox(infoboxContent, marker, position, callback) {
  closeAllWindows();
  var pinHeight = marker.pinHeight;
  mapInfoBox = new InfoBox(infoboxOptions);
  mapInfoBox.content_ = infoboxContent;
  mapInfoBox.marker = marker;
  mapInfoBox.spatialGuid = marker.spatialGuid;
  mapInfoBox.id = marker.id;
  mapInfoBox.type = marker.type;
  mapInfoBox.setZIndex(999);
  var contentDom = $.parseHTML(infoboxContent);

  // Mobile infobox is smaller than the desktop one, change the horizontal offet to accomodate this
  var horizontalOffset;
  if (Modernizr.mq('only screen and (max-width: 30em)')) {
    horizontalOffset = -140;
  } else {
    var hasEmptyPtag = true;
    $(contentDom)
      .find('p')
      .each(function () {
        if ($(this).html().length > 0) hasEmptyPtag = false;
      });
    if ($(contentDom).find('img').length > 0 || !hasEmptyPtag)
      horizontalOffset = -190;
    else {
      horizontalOffset = -115;
    }
  }
    mapInfoBox.pixelOffset_ = new google.maps.Size(
      horizontalOffset,
      (pinHeight + 15) * -1
    );
  map = marker.map;
  map.lastSourceItem = marker.sourceItem;
  mapInfoBox.open(marker.map, marker);
  mapInfoBox.addListener('domready', function () {
    
    var $infoBoxInner = $('.infoBox__inner');
    if(position == "ais"){
      $infoBoxInner = $('.infoBox__inner.ais');
    }

      var infoBoxInner_notLabel = $infoBoxInner.not('.label');
      if (infoBoxInner_notLabel.parent().width() < 380) {
        if (infoBoxInner_notLabel.width() < 230) {
          infoBoxInner_notLabel.width(230);
          infoBoxInner_notLabel.parent().css('width', 'auto');
        }
        horizontalOffset = infoBoxInner_notLabel.outerWidth() / -2;
        
          mapInfoBox.pixelOffset_ = new google.maps.Size(
            horizontalOffset,
            (pinHeight + 15) * -1
          );      
      }
    if (position == "ais") {
      var mapHeight = map.getDiv().offsetHeight;
      var mapWidth = map.getDiv().offsetWidth;
      var boxWidth = parseInt(infoBoxInner_notLabel.parent().css('width'));
      var boxHeight = parseInt(infoBoxInner_notLabel.parent().css('height'));
      horizontalOffset = (mapWidth / 2) - boxWidth - 50;
      mapInfoBox.pixelOffset_ = new google.maps.Size(
        horizontalOffset,
        250 // TODO: use dynamic instead (boxHeight / 2)
      );
    }

    if (position == "species") {
      horizontalOffset = infoBoxInner_notLabel.outerWidth() / -2;
      mapInfoBox.pixelOffset_ = new google.maps.Size(
        horizontalOffset,
        -40
      );
    }
    
  
    //set the max height of the description
    if ($infoBoxInner.css('max-height')) {
      var infoBoxInnerMaxHeight = parseInt($infoBoxInner.css('max-height'));
      var infoHeaderHeight = $('h2', $infoBoxInner).parent().outerHeight();
      var infoBoxCTAHeight = $('.infobox__ctaWrapper').outerHeight() || 0;
      var descriptionMaxHeight = infoBoxInnerMaxHeight - (infoHeaderHeight + infoBoxCTAHeight);

      if (position === 'ais') {
        descriptionMaxHeight -=
          parseInt($('.infoBox__inner__description').css('padding-top')) +
          parseInt($('.infoBox__inner__description').css('padding-bottom'));
      } else {
        descriptionMaxHeight -=
          $('h2 + p', $infoBoxInner).outerHeight() +
          parseInt($infoBoxInner.css('padding-top')) +
          parseInt($infoBoxInner.css('padding-bottom'));
      }

      $('.infoBox__inner__description').css('max-height', descriptionMaxHeight)
    }

    // prevent scrolling propagating to map when infobox scrolling is active
    // workaround due to infobox enableEventPropagation is not working
    // and to prevent google map controlling gesture message
    $('.infoBox__inner__description').on(
      'wheel',
      function (event) {
        event.stopPropagation();
      }
    );

    $('.infoBox__close').on('click', function (event) {
      //touchend event has no map.setOptions because it's buggy. If you touch the infobox inner first, the touchend has an error
      //if you touch the map and then the infobox, it's correctly done.
      if (Mzr.touch) {
        // console.log('set draggable to true');
        map.setOptions({ draggable: true });
        $('body').css('overflow', 'auto');
      }
      closeMapInfoWindow();
      closeInfoBox(true); // close the currently open info box

      event.stopPropagation(); // Stop clicks to underlying elements.  This is neccessary due to pointer-events none set in css on the element.

      if(marker.layer !== undefined && marker.layer!=null && marker.layer.clearActiveFeature !== undefined){
        marker.layer.clearActiveFeature();
      }
            
    });

    typeof callback === 'function' && callback();
  });
  
}

function  prepareLargeInfoboxForPrinting (infoboxObj) {
  var $infoBox = $(infoboxObj.div_);
  var $infoBoxClone = $infoBox
    .addClass('hidden-print')
    .removeClass('visibility-on-print')
    .clone();

  //move the clone
  $infoBoxClone
    .removeAttr('style')
    .addClass('visible-print infoBox-printOnly clearfix')
    .removeClass('hidden-print')
    .appendTo('#mapWrapper')
    .find('.infobox__ctaWrapper .button')
    .addClass('hidden-print');

  //create an infobox to be an indicator of the selected pin when printing
  printIndicatorInfoBox = createHoverInfobox(
    null,
    infoboxObj.marker,
    infoboxObj.marker.pinHeight,
    true
  );
}

function createHoverInfobox  (
  currentBox,
  marker,
  pinHeight,
  isVisibleForPrintingOnly
) {
  var anchor; //the anchor could be a marker or a cluster
  var offset; //this could be a pin height or an offset (if the anchor is a cluster cluster)
  var box = currentBox != null ? currentBox : new InfoBox(infoboxOptions);
  var title =
    (marker.type == 'ep' ? 'Park entry point: ' : '') + marker.title_;

  if (marker.type == 'subatt') {
    //var parentMarker = module.pins.findPinByItemId(marker.parentAttr);
    //title += ' (a part of ' + parentMarker.title_ + ')';
  }

  //set the visibility for printing
  if (isVisibleForPrintingOnly) {
    box.setOptions({
      boxClass: 'infoBox visibility-on-print',
    });
  }

  box.content_ =
    '<div class="infoBox__inner label"><p>' + title + '</p></div>';

  if (typeof marker.cluster !== 'undefined' && marker.cluster !== null) {
    var clusterMarker = marker.cluster;
    //this is needed to emulate a getPosition from a marker
    clusterMarker.getPosition = function () {
      return marker.cluster.getCenter();
    };
    offset = 15;
    anchor = clusterMarker;
  } else {
    offset = pinHeight || 2; //if pinHeight is undefined, use 2 instead (i.e clicking a route)
    anchor = marker;
  }

  //if entry point, the offset should be determined from the box.content, otherwise, it's the title/marker.title_
  box.pixelOffset_ = getInfoboxLabelOffset(
    marker.type == 'ep' ? box.content_ : title,
    offset
  );
  box.disableAutoPan_ = true;
  box.pin = marker;
  box.open(map, anchor);
  return box;
}

export function getInfoboxLabelOffset (label, pinHeight) {
  $('body').append(
    '<div class="infoBox__inner label offScreen"><p>' +
      label +
      '</p></div>'
  );
  var infoboxHorizontalOffset = $('body > .infoBox__inner').width();

  // Remove it
  $('body > .infoBox__inner').remove();

  // Use the width value to calculate an offset
  infoboxHorizontalOffset = (infoboxHorizontalOffset / 2) * -1 - 17; // multiple -1 one to make negative
  infoboxHorizontalOffset = new google.maps.Size(
    infoboxHorizontalOffset,
    (pinHeight + 15) * -1
  );

  return infoboxHorizontalOffset;
}
function closeHoverInfoBox () {
  // Closes the hover infobox
  if (hoverInfoBox != null) hoverInfoBox.close();
}
function closeMapInfoWindow(){
  if(typeof map !== 'undefined' && map != null){
    if(typeof map.infoWindow !== 'undefined' && map.infoWindow!=null){
      map.infoWindow.close();
    }
  }
}
function closeInfoBox(isTriggeredByUser) {
  // Closes the large infoboxes
    closeParkEntryInfoBox(); //close park entry infobox   

  //remove print-only infobox
  $('.infoBox-printOnly').remove();

  //close the print infobox
  if (
    typeof printIndicatorInfoBox !== 'undefined' &&
    printIndicatorInfoBox != null
  )
    printIndicatorInfoBox.close();

  if (mapInfoBox != null) {
    mapInfoBox.close();

    //unhiglight the region layer if there's a mapinfobox
    if (
      mapInfoBox.spatialGuid != null &&
      typeof regionLayer !== 'undefined'
    ) {
      // var style = regionLayer.getFeatureStyle(mapInfoBox.spatialGuid);
      var _thisInfoBox = mapInfoBox;
      // regionLayer.FindById(mapInfoBox.spatialGuid, function (feat) {
      // 	regionLayer.overrideStyle(feat, module.regionLayerSettings.inactiveRegions.styles.defaultState);
      // });

      /*regionLayer.setStyle(function (feat) {
        if (
          feat.getId() == _thisInfoBox.spatialGuid &&
          feat.getId() != regionLayer.layerClicked
        ) {
          return module.regionLayerSettings.inactiveRegions.styles
            .defaultState;
        } else if (feat.getId() == regionLayer.layerClicked) {
          return module.regionLayerSettings.activeRegion.styles
            .defaultState;
        } else {
          return module.regionLayerSettings.inactiveRegions.styles
            .defaultState;
        }
      });*/

      if (
        mapInfoBox.spatialGuid == regionLayer.layerClicked &&
        !isTriggeredByUser
      ) {
        // regionLayer.FindById(mapInfoBox.spatialGuid, function (feat) {
        // 	regionLayer.overrideStyle(feat, module.regionLayerSettings.activeRegion.styles.defaultState);
        // });
      }
    }

    mapInfoBox = null;
  }
  isInfoBoxHovered = false;
}
function closeParkEntryInfoBox() {
  if (typeof parkEntryInfoBox !== 'undefined' && parkEntryInfoBox != null)
    parkEntryInfoBox.close();
}

function testActiveLayer(event, isForRouteLayer) {
  return false;
  // If a layer is to be set as the active layer for a particular map, do nothing
  var pin = module.pins.findPinByItemId(mapSettings.selected);

  if (pin != null) {
    //if it's called for route layer
    if (
      typeof isForRouteLayer !== 'undefined' &&
      isForRouteLayer &&
      typeof event.feature !== 'undefined' &&
      event.feature !== null
    ) {
      //the pin has to be the route pin and has the same spatialGuid
      return (
        module.pins.isRoutePin(pin) &&
        event.feature.getId() == pin.spatialGuid
      );
    }

    if (typeof event.feature !== 'undefined' && event.feature !== null) {
      if (event.feature.getId() == pin.spatialGuid) {
        return true;
      }
    } else {
      if (
        typeof event.featuredId !== 'undefined' &&
        event.featureId !== null
      ) {
        if (event.featureId == pin.spatialGuid) {
          return true;
        }
      }
    }
  }

  return false;
}
